module.exports = __webpack_public_path__ + "img/23t.prt.987e8c1e.jpg";